import { render } from "./CorrectionItemMobile.vue?vue&type=template&id=17749abe&scoped=true"
import script from "./CorrectionItemMobile.vue?vue&type=script&lang=js"
export * from "./CorrectionItemMobile.vue?vue&type=script&lang=js"

import "./CorrectionItemMobile.vue?vue&type=style&index=0&id=17749abe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17749abe"]])

export default __exports__